import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../AuthContext";
import ViewQA from '../components/QA/ViewQA';
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary
function QAPage() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [products, setAllProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [updatePage, setUpdatePage] = useState(true);
  const [stores, setAllStores] = useState([]);
  const { theme } = useTheme(); // Get the theme from context
  
  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center">
            <div className="flex flex-col gap-5 w-full"> {/* Flex column with full width */}
              <ViewQA/>
      </div>
    </div>
  );
}

export default QAPage;
